import { Inject } from 'inversify-props'
import { FechamentoDeCaixaServiceAdapter } from './adapter'
import { FechamentoDeCaixa, FormDeFechamentoDeCaixa } from '@/models'

export class SaveFechamentoDeCaixaUseCase {
	@Inject('FechamentoDeCaixaServiceAdapter')
	private fechamentoDeCaixaService!: FechamentoDeCaixaServiceAdapter
	
	update = async (fechamentoDeCaixa: FormDeFechamentoDeCaixa): Promise<FechamentoDeCaixa> =>
		await this.fechamentoDeCaixaService.update(fechamentoDeCaixa)

	registrarLogDeAlteracaoDeUsuario = async (usuarioAtual: string, usuarioAntigo: string, usuarioNovo: string): Promise<void> => 
		await this.fechamentoDeCaixaService.registrarLogDeAlteracaoDeUsuario(usuarioAtual, usuarioAntigo, usuarioNovo);
}
